import React, { useState } from "react";

function Arayoor() {
 return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/bg.jpg)',backgroundSize:'cover',backgroundPosition:'center'}}>
      </div>
      <div className="" style={{backgroundImage:'url(./images/event.jpeg)',padding:'10px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}}>
            
            <div className="col-md-12" style={{background:'#ffeccaf6',padding:'90px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange',borderRadius:'15px'}}>
                    <div className="col-md-8" style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',flexWrap:'wrap',gap:'25px'}}>
                       <center><p className="enquiry" >Arayoor</p> </center> 
                       {/* <p className="enquiry" style={{fontSize:'20pt',marginBottom:'15px'}}>His Purvashram as little Velayudhan</p>  */}
                       <p className="enq-para" >Gurudev first had installed a mirror as the deity. Besides, there are temples dedicated to Mother goddess and Shiva in the premises. The roof of the main temple is in the form of Meruchakra (Three dimensional form of the holy Sree Chakra). The idol of Gurudev was installed in the apartment where he lived.</p>
                    </div>
                    <div className="col-md-4">
                        <img src="/images/gurudev-1.jpeg" alt="Guruji" style={{width:'100%'}} />
                    </div>
                </div>
                
                <div className="row" style={{marginBottom:'50px',paddingBottom:'15px',paddingTop:'15px'}}>
                    
                    {/* details */}
                    <div className="row" style={{marginBottom:'50px',background:'white',borderRadius:'15px'}}>
                    
                        
                    </div>
                    
                   
                </div>
                
                
           </div> 
          
                      
        </div>
        
        
      </div>
    </div>
  );
}

export default Arayoor;